<template>
  <v-container>
    <v-card>
      <v-container class="pa-5" fill-height>
        <v-row>
          <v-col>
            <project-asset v-on:project-changed="onProjectChange" v-on:vessel-changed="onVesselChange" @set-date="setDate"></project-asset>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" sm="3" md="3">
            <date-input v-model="startDate" @input="refreshDprs()" :label="$t('common.startDate')"> </date-input>
          </v-col>
          <v-col cols="3" sm="3" md="3">
            <date-input v-model="endDate" :min="startDate" :label="$t('common.endDate')" @input="refreshDprs()"> </date-input>
          </v-col>
        </v-row>
        <v-spacer class="mb-5"></v-spacer>
        <v-card width="100vw" class="elevation-0">
          <v-data-table :headers="headers" :items="items" :items-per-page="10" class="elevation-0">
            <template slot="item" slot-scope="props">
              <tr>
                <td>
                  {{ props.item.dprNumber }}
                </td>
                <td style="text-align: left">
                  {{ dateMixin(props.item.dprDate) || props.item.dprDate }}
                </td>

                <td style="text-align: left">
                  {{ dateMixin(props.item.issueDate) || props.item.issueDate }}
                </td>
                <td style="text-align: left">{{ props.item.projectName }}</td>
                <td style="text-align: left">{{ props.item.vesselName }}</td>
                <td style="text-align: left">
                  <v-btn color="white" x-small fab elevation="1" @click="viewDpr(props.item)">
                    <v-icon v-if="props.item.isReadOnly == true" small color="primary"> visibility </v-icon>
                    <v-icon v-if="props.item.isReadOnly == false" small color="primary"> mdi-pencil </v-icon></v-btn
                  >
                  <v-btn v-if="props.item.noOfFiles == 0" class="ml-2" color="white" x-small fab elevation="1" @click="deleteItem(props.item)">
                    <v-icon small color="primary"> mdi-delete </v-icon>
                  </v-btn>
                  <span v-if="props.item.noOfFiles > 0">
                    <v-tooltip bottom v-for="fv in props.item.noOfFiles" v-bind:key="fv">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-2" color="white" x-small fab elevation="1" v-bind="attrs" v-on="on" @click="viewDprPdfVersion(props.item, fv)">
                          <v-icon small color="primary">mdi-file-pdf</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("pdf.viewVersion") }} {{ fv }}</span>
                    </v-tooltip>
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import moment from "moment";
import Vue from "vue";
import ProjectAsset from "../components/common/ProjectAsset.vue";

export default {
  components: {
    "project-asset": ProjectAsset,
  },
  data() {
    return {
      startDate: moment
        .utc()
        .add(-30, "days")
        .format("DD/MMM/YYYY"),
      endDate: moment.utc().format("DD/MMM/YYYY"),
      headers: [
        {
          text: this.$t("header.number"),
          align: "left",
          sortable: true,
          value: "dprNumber",
        },
        {
          text: this.$t("dprSearch.date"),
          align: "left",
          sortable: true,
          value: "dprDate",
        },
        {
          text: this.$t("dprSearch.issuedDate"),
          align: "left",
          value: "issueDate",
        },
        {
          text: this.$t("common.projectName"),
          align: "left",
          value: "projectName",
        },
        {
          text: this.$t("common.asset"),
          align: "left",
          value: "vesselName",
        },
        {
          text: this.$t("column.actions"),
          align: "left",
          value: "actions",
          sortable: false,
          width: "35%",
        },
      ],
      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null,
      pvDate: null,
    };
  },
  computed: {
    ...mapGetters(["mv_prjSearch/getPrjDate", "getProjectVesselMappings", "mv_dprData/getCurrentDprMainId", "mv_dprData/getDprPVId", "mv_dprData/getDprFiles", "mv_dprData/getDprs", "m_project/getProjectNames", "m_project/getProjectVesselIds", "m_vessel/getVesselNames", "m_passet/getSelProjectId", "m_passet/getSelVesselId", "m_passet/getSelProjectVesselIds"]),
    items() {
      return this["mv_dprData/getDprs"] ? this["mv_dprData/getDprs"] : [];
    },
    files() {
      return this["mv_dprData/getDprFiles"];
    },
    filesNumber() {
      return this["mv_dprData/getDprFiles"].length;
    },
    isDisabled() {
      return this.items.length > 0 ? true : false || true;
    },
    projects() {
      return this["m_project/getProjectNames"].filter((p) => p.VCount > 0);
    },
    vessels() {
      return this["m_vessel/getVesselNames"];
    },
    projectVessels() {
      let vessels = this.vessels;

      let pvIds = this["m_passet/getSelProjectVesselIds"];
      if (this.dlgSelProjectId) {
        pvIds = this["m_project/getProjectVesselIds"];
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1);
    },
  },

  watch: {
    pvDate: function() {
      if (this.pvDate) (this.startDate = moment(this.pvDate.firstDPRDate).format("DD/MMM/YYYY")), (this.endDate = moment(this.pvDate.lastDPRDate).format("DD/MMM/YYYY")), this.refreshDprs();
    },
  },

  methods: {
    ...mapMutations(["mHideLongLoader", "mShowInfoMessage", "mv_dprData/SET_CURRENT_DPR_MAIN_ID", "mv_dprHeader/SET_DPR_HEADER"]),
    ...mapActions(["mv_prjSearch/fetchPrjData", "fetchProjectVesselMappings", "loadUserContext", "mv_dprData/fetchDprs", "mv_dprData/fetchDprFiles", "mv_dprData/deleteInSearch", "mv_dprHeader/deleteDprHeader", "m_project/fetchProjectVesselNames"]),

    onProjectChange(value) {
      this.selProjectId = value;
      this.refreshDprs();
    },

    onVesselChange(value) {
      this.selVesselId = value;
      this.refreshDprs();
    },

    async setDate(pId, vId) {
      console.log("SETDATE");
      await this.fetchProjectVesselMappings();
      let prjVessel = this["getProjectVesselMappings"].filter((pv) => pv.projectId == pId && pv.vesselId == vId);

      await this["mv_prjSearch/fetchPrjData"](prjVessel[0]["id"]);
      this.pvDate = this["mv_prjSearch/getPrjDate"];
    },

    refreshDprs() {
      let pId = this.selProjectId;
      let vId = this.selVesselId;

      this["mv_dprData/fetchDprs"]({
        pId: pId,
        vId: vId,
        startDate: this.startDate,
        endDate: this.endDate,
      });

      localStorage.dprStartDate = this.startDate;
      localStorage.dprEndDate = this.endDate;
    },

    viewDprPdfVersion(dpr, fileVersion) {
      let dprMainId = dpr.dprMainId;
      this.$log.debug("view dpr", dprMainId, "pdf report version", fileVersion);
      window.open(Vue.$url("dpr-header/" + dprMainId + "/pdf-report?fv=" + fileVersion), "_blank");
    },

    viewDpr(dpr) {
      let dprMainId = dpr.dprMainId;
      this.$log.debug("updating DPR to", dprMainId, "redirecting to header");
      this["mv_dprData/SET_CURRENT_DPR_MAIN_ID"](dprMainId);
      this.$router.push({ name: "dprHeader", params: { dprMainId: dprMainId, pvId: dpr.projectVesselId }, query: { pclsd: dpr.isProjectClosed ? 1 : 0 } });
    },

    deleteItem(item) {
      var msg = "warning.delete";
      this.$confirm(this.$t(msg) + " entry ?", {
        buttonTrueText: this.$t("common.ok"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((res) => res && this["mv_dprHeader/deleteDprHeader"](item.dprHeaderId).then(this.refreshDprs));
    },
  },

  mounted() {
    let sd = moment
      .utc()
      .clone()
      .startOf("month")
      .format("DD/MMM/YYYY");
    let ed = moment
      .utc()
      .clone()
      .endOf("month")
      .format("DD/MMM/YYYY");

    this.startDate = localStorage.dprStartDate || sd;
    this.endDate = localStorage.endDate || ed;
  },

  created() {
    this.selProjectId = this["m_passet/getSelProjectId"];
    this.selVesselId = this["m_passet/getSelVesselId"];

    this.$log.debug("clearing current dpr ...");
    this["mv_dprData/SET_CURRENT_DPR_MAIN_ID"](null);
    this["mv_dprHeader/SET_DPR_HEADER"](null);
    this.refreshDprs();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
};
</script>
<style scoped>
.container {
  max-width: 95%;
}
</style>
